<template>
  <div>
    <div class="bsd-section" v-if="reenrollmentAvailableStatus">
      <reenrollment-alert :reenrollment-status="reenrollmentAvailableStatus" />
    </div>

    <div class="bsd-section" v-if="hasOpenContractDischargePayment">
      <open-contract-discharge-alert :payment-method="paymentMethod" :period-name="currentContract.period_name" />
    </div>

    <div class="bsd-section" v-if="student.email_to_confirm && student.email_to_confirm !== {}">
      <email-confirmation-alert :email="student.email_to_confirm" :change-solicitated="student.change_solicitated" />
    </div>
  </div>
</template>

<script>
import ContractFullPaymentService from 'services/ContractFullPaymentService';
import { mapState } from 'vuex';
import OpenContractDischargeAlert from './open-contract-discharge-alert';
import EmailConfirmationAlert from './email-confirmation-alert';
import ReenrollmentAlert from './reenrollment-alert';

export default {
  components: {
    OpenContractDischargeAlert,
    ReenrollmentAlert,
    EmailConfirmationAlert,
  },
  data() {
    return {
      hasOpenContractDischargePayment: false,
      paymentMethod: '',
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
      'currentContract',
      'student',
    ]),
    reenrollmentAvailableStatus() {
      return this.currentBilling.reenrollment_available_status;
    },
  },
  methods: {
    loadExistingContractDischargeRequest() {
      ContractFullPaymentService.getExistingPaymentPromise(this.currentContract.id)
        .then(({ request }) => {
          if (request && request.status === 'pending' && this.hasPaymentPromise(request)) {
            if (request.boleto_payment_promise) {
              this.paymentMethod = 'boleto';
            } else if (request.pix_payment_promise) {
              this.paymentMethod = 'pix';
            }
            this.hasOpenContractDischargePayment = true;
          }
        });
    },
    hasPaymentPromise(dischargeRequest) {
      return dischargeRequest.boleto_payment_promise || dischargeRequest.pix_payment_promise;
    },
  },
  mounted() {
    this.loadExistingContractDischargeRequest();
  },
};
</script>
